document.addEventListener("DOMContentLoaded", function () {
  const form = document.getElementById("customer_login");
  const emailInput = document.getElementById("CustomerEmail");
  const passwordInput = document.getElementById("CustomerPassword");
  const loginButton = document.querySelector(".login_validation-button");
  const recaptchaErrorDiv = document.querySelector(".captcha-alert");
  const recaptchaCloseBtn = recaptchaErrorDiv?.querySelector(
    "span[aria-hidden='true']"
  );
  const emailError = emailInput.closest(".input-wrapper").nextElementSibling;
  const passwordError =
    passwordInput.closest(".input-wrapper").nextElementSibling;
  const formMessage = document.querySelector(".form__message");
  const errorsDiv = document.querySelector(".errors");
  const recoverPassLink = document.querySelector(".recover-pass");

  function validateEmail(email) {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(email);
  }

  function showError(errorElement, message) {
    if (errorElement) {
      errorElement.textContent = message;
      errorElement.style.display = "block";
    }

    if (formMessage) formMessage.classList.add("hidden");
    if (errorsDiv) errorsDiv.classList.add("hidden");
  }

  function clearError(errorElement) {
    if (errorElement) {
      errorElement.textContent = "";
      errorElement.style.display = "none";
    }
  }

  // Prevent Enter key from submitting the form
  form.addEventListener("keydown", function (event) {
    if (event.key === "Enter") {
      event.preventDefault();
    }
  });

  loginButton.addEventListener("click", function (event) {
    event.preventDefault();
    let isValid = true;

    if (formMessage) formMessage.classList.add("hidden");
    if (errorsDiv) errorsDiv.classList.add("hidden");

    if (emailInput.value.trim() === "") {
      showError(emailError, "Por favor, insira seu endereço de e-mail.");
      isValid = false;
    } else if (!validateEmail(emailInput.value.trim())) {
      showError(emailError, "Por favor, insira um endereço de e-mail válido.");
      isValid = false;
    } else {
      clearError(emailError);
    }

    if (isValid && passwordInput.value.trim() === "") {
      showError(passwordError, "Digite sua senha.");
      isValid = false;
    } else {
      clearError(passwordError);
    }

    if (isValid) {
      form.submit();
    }
  });

  if (recoverPassLink) {
    recoverPassLink.addEventListener("click", function () {
      recaptchaErrorDiv.classList.add("hidden");
    });
  }

  if (recaptchaCloseBtn) {
    recaptchaCloseBtn.addEventListener("click", function () {
      recaptchaErrorDiv.classList.add("hidden");
    });
  }

  let isRecaptchaOpen = false;
  document.addEventListener("click", function (event) {
    const recaptchaPopup = document.querySelector(".g-recaptcha");
    const recaptchaIframe = document.querySelector(
      ".g-recaptcha-bubble-arrow"
    )?.parentElement;
    const customerLogin = document.querySelector("#customer_login");

    if (recaptchaIframe && recaptchaIframe.style.visibility !== "hidden") {
      isRecaptchaOpen = true;
    } else {
      isRecaptchaOpen = false;
    }

    if (
      isRecaptchaOpen &&
      recaptchaPopup &&
      !recaptchaPopup.contains(event.target) &&
      !customerLogin.contains(event.target)
    ) {
      if (typeof grecaptcha !== "undefined") {
        grecaptcha.reset();
        isRecaptchaOpen = false;
      }
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const recoverForm = document.querySelector("form[action='/account/recover']");
  const recoverEmailInput = document.getElementById("RecoverEmail");
  const recoverButton = document.querySelector(".recover_validation-button");
  const emailError =
    recoverEmailInput.closest(".input-wrapper").nextElementSibling;

  function validateEmail(email) {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(email);
  }

  function showError(errorElement, message) {
    if (errorElement) {
      errorElement.textContent = message;
      errorElement.style.display = "block";
    }
  }

  function clearError(errorElement) {
    if (errorElement) {
      errorElement.textContent = "";
      errorElement.style.display = "none";
    }
  }

  recoverButton.addEventListener("click", function (event) {
    event.preventDefault();
    let isValid = true;

    // Email Validation
    if (recoverEmailInput.value.trim() === "") {
      showError(emailError, "Por favor, insira seu endereço de e-mail.");
      isValid = false;
    } else if (!validateEmail(recoverEmailInput.value.trim())) {
      showError(emailError, "Por favor, insira um endereço de e-mail válido.");
      isValid = false;
    } else {
      clearError(emailError);
    }

    // Submit form if validation passes
    if (isValid) {
      sessionStorage.setItem('recoverEmail', recoverEmailInput.value)
      recoverForm.submit();
    }
  });
});

// Show recover email in success popup 
const recoverEmail = sessionStorage.getItem('recoverEmail');
const successPopupEl = document.querySelector('.recover-password-popup__wrapper .recover-mailid')
const loginWrapper = document.querySelector('.customer-login__wrapper');
if (recoverEmail && successPopupEl) {
  successPopupEl.textContent = recoverEmail;
  if (loginWrapper) {
    loginWrapper.style.display = 'none';
  }
}

// Hide popup 
const backToLogin = document.querySelector('.recover-password-popup__wrapper .recover-password-cancel');
backToLogin?.addEventListener('click', (event) => {
  const popupWrapper = document.querySelector('.recover-password-popup__wrapper');
  event.preventDefault();
  if (loginWrapper) {
    loginWrapper.style.display = 'flex'
  }
  popupWrapper?.classList.add('hidden');
})

// Clear recover input and error message when user click back button
const forgotBackButton = document.querySelector('.login-container .recover-password-cancel');
forgotBackButton?.addEventListener('click', () => {
  const recoverPasswordInput = document.querySelector('.recover_pass #RecoverEmail');
  const errorMessage = document.querySelector('.recover_pass .error_message');
  recoverPasswordInput.value = '';
  errorMessage.textContent = '';
})

// clear login inputs and error messages when user click forgot password 
const forgotPassword = document.querySelector('#customer_login .recover-pass');
forgotPassword?.addEventListener('click', () => {
  const loginInputs = document.querySelectorAll('#customer_login input');
  const loginErrormessages = document.querySelectorAll('#customer_login .error_message');
  loginInputs?.forEach((each) => each.value = '');
  loginErrormessages?.forEach((each) => each.textContent = '');
})